export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/gaming.0c19284.svg";